import { ROLES } from './ROLES';

export const PERMISSIONS = {
    [ROLES.COMPRAS_SR]: [
        'digibox',
        'home',
        'companies',
        'categories',
        'buscador',
        'orders',
        'influencers',
        'news',
        'profile',
        'cart',
        'materialpop',
        'pop',
        'pop-orders',
        'pop-cart',
        'rfq',
        'automobiles',
        'automobiles-beta',
        'rfq-pop',
        'rfq-pop-products',
        'searches',
        'reports',
        'premium-orders',
        'printed',
        'printed-cart',
        'printed-orders',
        'pop-orders-test',
        'rfq-printed',
        'rfp',
        'custom',
        'notification-center',
        'users',
        'mercadolibre',
        'help'
    ],
    Agencia: ['profile'],
    Proveedor: [
        'about',
        'profile',
        'providers',
        'admin',
        'products',
        'notification-center',
        'users',
        'help'
    ],
    [ROLES.COMPRAS]: [
        'digibox',
        'home',
        'companies',
        'categories',
        'buscador',
        'orders',
        'influencers',
        'news',
        'profile',
        'cart',
        'materialpop',
        'pop',
        'pop-orders',
        'pop-cart',
        'rfq',
        'automobiles',
        'automobiles-beta',
        'rfq-pop',
        'rfq-pop-products',
        'searches',
        'premium-orders',
        'printed',
        'printed-cart',
        'printed-orders',
        'rfq-printed',
        'rfp',
        'custom',
        'notification-center',
        'mercadolibre',
        'help'
    ],
    RH: [
        'home',
        'categories',
        'buscador',
        'profile',
        'automobiles',
        'automobiles-beta',
        'news',
        'admin-autos',
        'users',
        'help'
    ],
    Public: ['profile', 'automobiles-beta'],
    Calidad: [
        'home',
        'companies',
        'categories',
        'buscador',
        'orders',
        'influencers',
        'quality',
        'news',
        'profile',
        'cart',
        'rfq',
        'automobiles',
        'premium-orders',
        'notification-center',
        'help'
    ]
};
